export default "__VITE_ASSET__8TN3ssMd__"